import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {StateService} from "../../services/StateService";
import {State} from "../../models/State";
import {Router} from "@angular/router";
import {TasksService} from "../../services/Tasks.service";
import {Session} from "../../services/Session";
import {LoadingService} from "../../services/LoadingService";

@Component({
  selector: 'app-dashboard-tasks',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-tasks.component.html',
  styleUrl: './dashboard-tasks.component.scss'
})
export class DashboardTasksComponent implements OnInit, OnDestroy {
  org: string = Session.getOrg();
  user: any = {};
  columns: Array<any> = [
    {name: 'customerName', title: 'Client', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
    {name: 'title', title: 'Name', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
    {name: 'dueDate', title: 'Due Date', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
    {name: 'status', title: 'Status', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
  ];
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  tasksList: Array<any> = [];

  constructor(
    private _router: Router,
    private stateService: StateService,
    private tasksService: TasksService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
    this.getTasksList();
  }

  getTasksList() {
    const base = this;
    const filterObj = {date: 'Next 7 Days', status: '', assignees: [Session.get('user').id], company: '', type: '', fromDate: '', toDate: '', display: 'list'};
    const taskIndex = 0;
    this.tasksService.clientTasks(filterObj, taskIndex)
      .subscribe(response => {
        this.tasksList = response.tasksList;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
      });

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  navigateToTasksSinglePage(task) {
    this.stateService.addState(new State('DASHBOARD', this._router.url, null, null));
    const link = ['clients', task.clientId, 'task', task.id, 'singlePage'];
    this._router.navigate(link);
  }

}
